import { useTranslation } from "react-i18next";
import { Icon, Label, Modal } from "semantic-ui-react";

import { DEALER_DOCUMENTATION_CATEGORIES } from "models";
import { PublisherInformation, ReadingModalImage } from "modules/DealerDocumentations/components/DealerDocumentationReadingModal/components";
import "modules/DealerDocumentations/components/DealerDocumentationReadingModal/DealerDocumentationReadingModal.scss";
import { enumToDropdownOptions } from "utils/common";

import type { DealerDocumentation } from "models";

type DealerDocumentationReadingModalProps = {
  documentation: DealerDocumentation | null;
  handleCloseViewModalDocumentation: () => void;
};

export const DealerDocumentationReadingModal = ({ documentation, handleCloseViewModalDocumentation }: DealerDocumentationReadingModalProps) => {
  const { t } = useTranslation();

  const categoryOptions = enumToDropdownOptions({ enumObj: DEALER_DOCUMENTATION_CATEGORIES, t });
  const categoryName = documentation?.category_id ? categoryOptions.find(({ value }) => value === documentation.category_id)?.text : "";

  return (
    <Modal className="DealerDocumentationReadingModal" open={!!documentation} size="large">
      <Modal.Header className="dealer-modal-header">
        <div className="document-info">
          <span>{documentation?.title}</span>
          {documentation?.is_pinned && <Icon className="pin" />}
          <Label className="category-name-dealer">{categoryName}</Label>
        </div>
        <button className="exitModal" onClick={handleCloseViewModalDocumentation}>
          <Icon className="x" size="large" />
        </button>
      </Modal.Header>
      <Modal.Content>
        <PublisherInformation documentation={documentation} />
        {documentation?.url && <ReadingModalImage url={documentation.url} />}
        <div className="dealer-modal-content">
          <div dangerouslySetInnerHTML={{ __html: documentation?.content || "" }}></div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
